import { colorConstants } from 'config/colorConstants';
import { renderTitle } from './getSalesAttributionColumns';
import DownSvg from 'assets/svg/Down';
import UpAltSvg from 'assets/svg/UpAlt';
import { Popover } from 'antd';
import {
    graphXAxisLabelFontSize,
    groupBarChartWidth,
} from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import { trackEventMixpanel } from './mixpanel';
import { PROMO_LANDSCAPE_TABLE_ROW_EXPANDED } from './mixpanelEventNames';

//attribute sales column generator
export const getPromoLandscapeColumns = (
    data: any,
    expandedIndex: null | number,
    setExpandedIndex: Function,
    absTile: any,
): any => {
    let result = [];
    const keys = data && data.length > 0 ? Object.keys(data?.[0]) : [];
    const sliceKeys = Array.isArray(keys) ? keys.slice(0, keys?.length - 1) : [];
    const columns =
        data && data.length > 0
            ? sliceKeys.map((item: any, index: number) => {
                  return {
                      title:
                          index === 0 || index === sliceKeys.length - 1
                              ? ''
                              : renderTitle(
                                    item,
                                    undefined,
                                    undefined,
                                    'text-purpleFont !font-bold',
                                    graphXAxisLabelFontSize,
                                ),
                      //title: index > 1 ? renderTitle(item) : '',
                      dataIndex: item,
                      key: item,
                      align: index === 0 ? 'left' : 'center',
                      fixed: index === 0 || index === 1 ? 'left' : null,
                      width: index === 0 ? 150 : groupBarChartWidth,
                      onCell: (rowData: any, rowIndex: any) => {
                          const hideNestedData =
                              rowData['nestedIndex'] !== null && rowData['nestedIndex'] !== expandedIndex;

                          return {
                              style: {
                                  textAlign: index === 0 ? 'auto' : 'center',
                                  backgroundColor:
                                      expandedIndex !== null &&
                                      (rowData['nestedIndex'] === expandedIndex || rowIndex === expandedIndex)
                                          ? colorConstants.lightPurple
                                          : 'white',
                              },
                              colSpan: hideNestedData ? 0 : 1,
                          };
                      },

                      //else render data
                      render(columnData: any, rowData: any, rowIndex: any) {
                          const hideNestedData =
                              rowData['nestedIndex'] !== null && rowData['nestedIndex'] !== expandedIndex;
                          //if index ===0 render label
                          if (!hideNestedData && index === 0) return <div className="font-xs">{columnData}</div>;

                          // if index is last render dropdown
                          if (!hideNestedData && index === sliceKeys.length - 1 && rowData['isExpandable']) {
                              return (
                                  <span
                                      onClick={() => {
                                          //resetting
                                          if (expandedIndex === rowIndex) setExpandedIndex(null);
                                          else {
                                              trackEventMixpanel(PROMO_LANDSCAPE_TABLE_ROW_EXPANDED, {
                                                  rowName: rowData?.label,
                                              });
                                              setExpandedIndex(rowIndex);
                                          }
                                      }}
                                      className="cursor-pointer"
                                  >
                                      {expandedIndex === rowIndex ? <UpAltSvg /> : <DownSvg />}
                                  </span>
                              );
                          }

                          //else render data
                          if (!hideNestedData && typeof columnData === 'object' && absTile?.key in columnData) {
                              //render text (for optimal investment index)
                              if (typeof columnData[absTile.key] === 'object' && 'color' in columnData[absTile.key]) {
                                  return (
                                      <div
                                          className="font-xs"
                                          style={{
                                              color: columnData[absTile.key]['color'],
                                              fontWeight: 700,
                                          }}
                                      >
                                          {item != 'Total' && columnData[absTile.key]['label']}
                                      </div>
                                  );
                              }
                              //render numbers
                              return (
                                  <Popover placement="bottom" content={renderPopoverContent(rowData, columnData)}>
                                      <span className="font-xs">{columnData[absTile.key] || ''}</span>
                                  </Popover>
                              );
                          }

                          return '';
                      },
                  };
              })
            : [];

    result = [...columns];
    return result;
};

const renderPopoverContent = (contentObj: any, columnData: any) => {
    return (
        <div className="flex flex-col gap-2 text-greyFont min-w-[150px] font-xxs">
            <div className="flex gap-4 justify-between">
                <p>CY {contentObj.label}</p>
                <p className="font-medium">{columnData.cy}</p>
            </div>
            <div className="flex gap-4 justify-between">
                <p>YA {contentObj.label}</p>
                <p className="font-medium">{columnData.ya}</p>
            </div>
            <div className="flex gap-4 justify-between">
                <p>Abs Change</p>
                <p className="font-medium">{columnData.absChange}</p>
            </div>
            <div className="flex gap-4 justify-between">
                <p>% Change</p>
                <p className="font-medium">{columnData.percentageChange}</p>
            </div>
        </div>
    );
};
